import { Row } from "antd";
import { SingleSelect } from "../../../../components/SingleSelect";
import { useCallback, useMemo } from "react";
import { IOption } from "../../../../types/Option";
import { PAYMENT_RESTRICTIONS } from "../../../../lib/constants";
import { useSearchParams } from "react-router-dom";

type RestrictionSelectProps = {
  request: any;
  isLoading: boolean;
};

export const RestrictionSelect = ({
  request,
  isLoading,
}: RestrictionSelectProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, setSearchParams] = useSearchParams();

  const setRestrictionFilter = useCallback(
    (value: string | number) => {
      const params = { ...request, pageNumber: 1 };

      if (value === 7) {
        delete params["paymentRestriction"];
      } else {
        params["paymentRestriction"] = +value;
      }

      setSearchParams(params);
    },
    [request, setSearchParams],
  );

  const restrictionOptions: IOption[] = useMemo(() => {
    const options = [...PAYMENT_RESTRICTIONS];

    options.unshift({ label: "All", value: 7 });

    return options;
  }, []);

  const displayValue = useMemo(() => {
    const { paymentRestriction } = request;

    return ![null, undefined].includes(paymentRestriction)
      ? +paymentRestriction
      : 7;
  }, [request]);

  return (
    <Row className="mr-4 payment-select restriction">
      <SingleSelect
        options={restrictionOptions}
        label="Restriction"
        value={displayValue}
        onChange={setRestrictionFilter}
        loading={isLoading}
        selectWidth={false}
      />
    </Row>
  );
};
